import { getBEMCls } from '../classname'
import { usePersistFn } from 'ahooks'

const useBemClass = (key: string) => {
    const getCls = usePersistFn((...arg: string[]) => getBEMCls(key, ...arg))

    return getCls
}

export default useBemClass
